import { compressObject, uncompressObject } from "./compression";

interface LocalStorageObject {
  value: string;
  expiry: number;
}

interface SetLocalStorageProps {
  key: string;
  value: object;
  expiryMs: number;
}

const getCurrentTimestamp = (): number => {
  const currentDate = new Date();
  return currentDate.getTime();
};

export async function getFromLocalStorage<T>(
  key: string,
): Promise<T | undefined> {
  const json = localStorage.getItem(key);
  if (!json) {
    return undefined;
  }

  const { value, expiry } = JSON.parse(json) as LocalStorageObject;

  const currentDate = new Date();
  const timestamp = currentDate.getTime();

  if (expiry <= timestamp) {
    return undefined;
  }

  return uncompressObject(value);
}

export async function setLocalStorage({
  key,
  value,
  expiryMs,
}: SetLocalStorageProps): Promise<void> {
  const compressedData = await compressObject(value);

  const localStorageObject = JSON.stringify({
    expiry: getCurrentTimestamp() + expiryMs,
    value: compressedData,
  });

  localStorage.setItem(key, localStorageObject);
}

export function clearLocalStorage(): void {
  localStorage.clear();
}
